import { app } from '../app/app.js';
import { navigation } from '../app/navigation.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { AccountPanelBase } from './account_panel_base.js';

/**
 * Reset password panel.
 */
class ResetPwdPanel extends AccountPanelBase {
  static id = navigation.kResetPwdPanelId;

  initialize() {
    super.initialize();

    listenToEvent(this.formElement, 'submit', () => this.reset(), {
      blockUI: true,
      preventDefault: true,
    });
  }

  static markup = `
    <div class='spacer'></div>
    <div class='msg' hidden></div>
    <h1>Reset <span class='designation'>CamperAid</span> password</h1>
    <form class='default'>
      <input autocomplete='username'
             type='email'
             placeholder='Email'
             required readonly><br>
      <input autocomplete='new-password'
             type='password'
             placeholder='New password'
             required disabled><br>
      <button type='submit' disabled>Set new password</button>
    </form>
    <div class='spacer-3'></div>
  `;

  get historyState() {
    return [
      { page: this.page },
      `CamperAid - Reset password`,
      `${window.location.origin}/reset-pwd`,
    ];
  }

  async switchOn() {
    const { email, pwdRecoveryHash } = navigation.params;
    this.emailElement.value = email;

    super.switchOn();

    let error = await app.checkPasswordRecoveryHash(pwdRecoveryHash);
    if (error) {
      if (error == app.BadPasswordRecoveryHash) {
        this.msgBox.error(`
          It appears this password recovery link is obsolete.
          <a href='/recover-pwd'>Send</a> a new one?`);

        listenToEvent(
          this.messageBoxElement.querySelector('a'),
          'click',
          () => this.recover(email),
          {
            preventDefault: true,
            blockUI: true,
          }
        );
        return;
      }
      this.msgBox.unexpectedError();
      return;
    }

    this.submitButton.disabled = false;
    this.pwdElement.disabled = false;

    this.pwdElement.focus();
  }

  async reset() {
    this.msgBox.hide();

    const { email, pwdRecoveryHash } = navigation.params;
    let pwd = this.pwdElement.value;

    let error = await app.resetPassword(pwdRecoveryHash, pwd);
    if (error) {
      this.msgBox.unexpectedError();
      return;
    }

    return this.login(email, pwd);
  }
}

navigation.registerPanel(ResetPwdPanel);

export { ResetPwdPanel };
